module.exports = __webpack_public_path__ + "static/media/rc1.cf0d4a34.jpg";